import React from 'react';

const RadioCheckedIcon = ({ className }: { className: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" className={className}>
    <mask
      id="a"
      width={20}
      height={20}
      x={2}
      y={2}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M2 2h20v20H2z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="m10.833 15.835 5.875-5.875-1.166-1.167-4.709 4.708-2.375-2.375-1.167 1.167 3.542 3.542Zm1.167 4.5a8.115 8.115 0 0 1-3.25-.657 8.416 8.416 0 0 1-2.646-1.78 8.415 8.415 0 0 1-1.781-2.647 8.115 8.115 0 0 1-.657-3.25c0-1.152.22-2.236.657-3.25a8.415 8.415 0 0 1 1.781-2.646 8.415 8.415 0 0 1 2.646-1.78A8.115 8.115 0 0 1 12 3.667c1.153 0 2.236.219 3.25.656a8.416 8.416 0 0 1 2.646 1.781 8.415 8.415 0 0 1 1.78 2.646 8.115 8.115 0 0 1 .657 3.25 8.115 8.115 0 0 1-.656 3.25 8.415 8.415 0 0 1-1.781 2.646 8.416 8.416 0 0 1-2.646 1.781 8.115 8.115 0 0 1-3.25.657Z"
      />
    </g>
  </svg>
);
export default RadioCheckedIcon;
